import {format} from 'date-fns'
import _ from 'lodash'
const UAParser = require('ua-parser-js');

// Handy promise that can be used for testing delays
const later = async (delay) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, delay)
  })
}

const dynamicID = (prefix = 'dynamicID') =>
  // The only method that actually disables Chrome autofill
  `${prefix}-${Math.floor(Math.random() * Date.now().toString())}`

// Not recursive. Could enhance later.
const filterByModel = (obj, model) => {
  return _.pickBy(obj, (value, key) => {
    return Object.keys(model).indexOf(key) > -1
  })
}

const formatDate = (d, dateFormat = 'MM/dd/yyyy') => {
  return format(d, dateFormat)
}

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)]
}

const randomNumber = () => {
  return Math.ceil(Math.random() * 10000000)
}

const stringToArray = (str) => {
  if (!str) return []
  const PRIMARY_DELIMITER = `|`
  const SECONDARY_DELIMITERS = [` `, `,`, `;`, /\n/g]
  for (let DEL of SECONDARY_DELIMITERS) {
    str = DEL instanceof RegExp
      ? str.replace(DEL, PRIMARY_DELIMITER)
      : str.split(DEL).join(PRIMARY_DELIMITER)
  }
  if (str.indexOf(PRIMARY_DELIMITER) === -1) return [str.trim()]
  return str
    .split(PRIMARY_DELIMITER)
    .map((x) => x.trim())
    .filter((x) => Boolean(x))
}

// ========= Formatting Helpers ========= //
const truncateText = (text, limit = 50) => {
  if (!text) return ''
  return text.length > limit ? text.substring(0, limit) + '…' : text
}

const humanizeType = (type) => {
  if (!type) return ''
  return type
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}
// ====================================== //

const toggleFullScreen = () => {
  let doc = window.document
  let docEl = doc.documentElement

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}

const getDeviceAndBrowserInfo = () => {
  const {browser, device, engine, os} = UAParser();
  return {
    browser: `${browser.name} ${browser.version}`.trim(),
    device: _.isEmpty(device) ? 'PC' : `${device.vendor || ''} ${device.model || ''} ${device.type || ''}`.trim(),
    engine: `${engine.name} ${engine.version}`,
    os: `${os.name} ${os.version}`.trim(),
  }
};

const getLocalStorageUsage = () => {
  let total = 0;
  for (let x in localStorage) {
    if (localStorage.hasOwnProperty(x)) {
      total += ((localStorage[x].length * 2) + x.length * 2);
    }
  }
  return total;
};

const getLocalStorageQuota = async () => {
  const estimate = await navigator?.storage?.estimate();
  if (estimate) return estimate.quota;
  return null;
};

const getStorageUsageInfo = async () => {
  const usedBytes = getLocalStorageUsage();
  const quotaBytes = await getLocalStorageQuota();

  return {
    usedBytes,
    remainingBytes: quotaBytes - usedBytes,
    quotaBytes
  };
};

export default {
  later,
  randomElement,
  toggleFullScreen,
  formatDate,
  randomNumber,
  filterByModel,
  stringToArray,
  dynamicID,
  truncateText,
  humanizeType,
  getDeviceAndBrowserInfo,
  getStorageUsageInfo,
}

// Named exports for tree-shaking/import convenience
export {
  later,
  randomElement,
  toggleFullScreen,
  formatDate,
  randomNumber,
  filterByModel,
  stringToArray,
  dynamicID,
  truncateText,
  humanizeType,
  getDeviceAndBrowserInfo,
  getStorageUsageInfo,
}